export default __webpack_public_path__ + "static/hmrc-edc487ba53d54fe22331f8fc0dac7f30.png";